<template>
  <div>
    <div class="header">
      <div class="header_content">
        <!-- header -->
        <div class="content">
          <h4>Hello, {{ userName }}</h4>
          <div class="title">工作辛苦了！</div>
          <div class="box">
            <div class="box_time">
              <div class="left">
                <span class="time">{{ myHouser.hour }}</span>
                <span class="tipx">累计投入工时/人月</span>
              </div>
              <div class="line"></div>
              <div class="right">
                <span class="time">{{ myHouser.count }}</span>
                <span class="tipx">当前参与案件数</span>
              </div>
            </div>
            <div class="box_line"></div>
            <div class="box_notie">
              <van-icon name="volume-o" style="margin-right: 10px" />
              你有{{ myHouser.day }}天未提交工时登记，请及时处理
              <van-button
                to="/calendar"
                round
                type="primary"
                size="small"
                style="
                  margin-left: 10px;
                  height: 24px;
                  width: 50px;
                "
              >
                查看
              </van-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 待完成工作事项 -->
    <div class="matter">
      <div class="title">待完成工作事项</div>
      <div class="box">
        <div
          class="content"
          v-for="(item, index) in myBackList"
          :key="index"
          @click="onJump(item.id, item.id, 1)"
        >
          <div class="title_box">
            <div class="name">{{ item.caseName }}</div>
            <div class="other">
              {{ item.planName }}/{{ item.planEndTime }}完成
            </div>
            <div class="other">当前状态：{{ item.finishStatus_dictText }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 参与案件 -->
    <div class="caseBox">
      <div class="title">参与案件</div>
      <ActiveList
        v-for="(item, index) in myActiveList"
        :key="index"
        @click="onJump(item.planId, item.id, 2, item.caseStatus)"
        :nav="`${item.finalCustomer}/${item.caseType}/${
          item.time.split(' ')[0]
        }/${item.caseStatusName}`"
        :title="item.caseName"
        :time="item.countHour"
      ></ActiveList>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import { Button, Icon } from 'vant';
import ActiveList from '@/components/ActiveList.vue';
import { getUserInfo } from '@/http/myhome';
import { useRouter, useRoute } from 'vue-router';
import { getMyBacklog, getMyActiveCase, getMyCaseInfo } from '@/http/home';

export default defineComponent({
  components: {
    [Button.name]: Button,
    ActiveList,
    [Icon.name]: Icon,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const userName: any = ref('');
    const myBackList = ref([]);
    const myActiveList = ref([]);
    const myHouser = ref({});
    // 跳转
    const onJump = (item: string, pro: string, type: number, status: string) => {
      router.push({
        path: '/caseform',
        query: { projectId: pro, type, status },
      });
    };
    const getDatil = () => {
      // 首页统计
      getMyCaseInfo().then((res: any) => {
        myHouser.value = res.result;
      });
      // 待完成
      getMyBacklog().then((res: any) => {
        myBackList.value = res.result;
      });
      // 参与案件
      getMyActiveCase().then((res: any) => {
        myActiveList.value = res.result;
      });
    };
    if (sessionStorage.getItem('userName')) {
      getDatil();
      userName.value = sessionStorage.getItem('userName');
    } else {
      getUserInfo({ code: route.query.code }).then((res: any) => {
        const { name, id } = res.result;
        userName.value = name;
        sessionStorage.setItem('userId', id);
        sessionStorage.setItem('userName', name);
        getDatil();
      });
    }

    return {
      userName,
      myBackList,
      myActiveList,
      onJump,
      myHouser,
    };
  },
});
</script>
<style lang="scss" scoped>
.header {
  height: 260px;
}
.header_content {
  background: #5374e8;
  height: 170px;
  position: relative;
  .content {
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    top: 30px;
    h4 {
      width: 320px;
      margin: auto;
      color: #fff;
    }
    .title {
      font-size: 12px;
      color: #fff;
      width: 320px;
      margin: 10px auto;
    }
    .box {
      width: calc(100% - 40px);
      height: 140px;
      background: #fff;
      border-radius: 11px;
      margin: auto;
      padding: 10px;
      .box_time {
        display: flex;
        align-items: center;
        .line {
          width: 1px;
          height: 50px;
          background: #d2d2d2;
        }
        .left,
        .right {
          display: flex;
          flex-direction: column;
          flex: 1;
          text-align: center;
          .time {
            font-size: 40px;
            font-weight: bold;
          }
          .tipx {
            font-size: 12px;
            color: #767676;
          }
        }
      }
      .box_line {
        height: 1px;
        background: #ddd;
        margin: 20px;
      }
      .box_notie {
        font-size: 14px;
        text-align: center;
        color: #747474;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
.matter {
  margin-top: 20px;
  margin-left: 10px;
  .title {
    color: $titleColor;
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .box {
    display: flex;
    overflow: auto;
    .content {
      display: flex;
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
      border-radius: 8px;
      margin-right: 10px;
      flex-shrink: 0;
      white-space: nowrap;
      &::before {
        content: '';
        display: inline-block;
        width: 10px;
        background: #a7ffd9;
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
        margin-right: 5px;
      }
      font-size: 14px;
      padding: 0px 10px 0px 0;
      height: 100px;
      background: #fff;
      overflow: hidden;
      .name {
        font-size: 19px;
        color: #797979;
        font-weight: 500;
        margin: 10px 0;
      }
      .other {
        font-size: 14px;
        margin-bottom: 5px;
        color: #adadad;
      }
      .title_box {
        width: 200px;
        .name, .other {
          white-space: nowrap;
          text-overflow:ellipsis;
          overflow: hidden;
        }
      }
    }
  }
}
.caseBox {
  padding: 0 10px;
  margin-top: 20px;
  .title {
    color: $titleColor;
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 10px;
  }
}
</style>
